import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICurrency } from '@shared/interfaces/currency.interface';
import { ILoadUsers } from '@shared/interfaces/user.interface';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminSettingsCurrenciesService {

  private settings_currencies$ = new BehaviorSubject<any[]>([]);
  
  constructor(private http: HttpClient) { }

  setSettingsCurrency(currencies: any[]) {
    this.settings_currencies$.next(currencies);
  }

  getSettingsCurrency() {
    return this.settings_currencies$.asObservable();
  }

  loadCurrencies(page = 1, count = 50){
    let url = environment.apiUrl + `/currencies`;
    return this.http.get<ICurrency>(url);
  }

  createCurrency(body: any) {
    let url = environment.apiUrl + `/operator/currencies`;
    return this.http.post(url, body);
  }

  editCurrency(currency_id: number, body: any) {
    let url = environment.apiUrl + `/operator/currencies/${currency_id}`;
    return this.http.post(url, body);
  }

  deleteCurrency(currency_id: number) {
    let url = environment.apiUrl + `/operator/currencies/${currency_id}`;
    return this.http.delete(url);
  }

  // searchCurrency(page = 1, count = 50, search = ''){
  //   let url = environment.apiUrl + `/operator/users?page=${page}&count=${count}&search=${search}`;
  //   return this.http.get<ILoadUsers>(url);
  // }

}
